export default "/images/vendor/flag-icon-css/flags/4x3/kr.svg?6bd5eda73cbc171baedbec0f743fb793";